import axios from "axios";
import { ModalError, ModalSuccess } from "components";
import { useState } from "react";
import { getErrors } from "utils";
import { hardBaseUrl } from "services/urlConstant";
import ContractForm from "./Components/ContractForm";
import { useHistory } from "react-router";

function AddContract() {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + token,
  };
  const urlContract = `${hardBaseUrl}/publisher/contract`;
  const urlDocuments = `${hardBaseUrl}/contract-document`;

  const [loadingContract, setLoadingContract] = useState(false);

  const handlSubmitData = async (
    payload,
    supportingDocumentFiles,
    contractType
  ) => {
    const isSongContract = contractType === "Song Contract";
    const mainContractFormEndpoint = !isSongContract ? "/composer-main" : "";
    const mainContractDocumentsEndpoint = !isSongContract
      ? "/contract/composer-main"
      : "";

    try {
      setLoadingContract(true);

      let requestData;
      let requestHeaders = { ...headers };

      if (supportingDocumentFiles && supportingDocumentFiles.length > 0) {
        const formData = new FormData();
        const payloadForFormData = {
          ...payload,
          contract_composer_balances: payload.contract_composer_balances
            ? JSON.stringify(payload.contract_composer_balances)
            : "",
          ownership_percentages: JSON.stringify(payload.ownership_percentages),
          publisher_share_percentages: JSON.stringify(
            payload.publisher_share_percentages
          ),
        };
        Object.keys(payloadForFormData).forEach(key => {
          formData.append(key, payloadForFormData[key]);
        });

        supportingDocumentFiles?.map(file =>
          formData.append("documents", file)
        );

        requestData = formData;
      } else {
        requestData = payload;
        requestHeaders["Content-Type"] = "application/json";
      }

      const res = await axios.post(
        `${urlContract}${mainContractFormEndpoint}`,
        requestData,
        { headers: requestHeaders }
      );

      if (res?.status === 200) {
        if (supportingDocumentFiles && supportingDocumentFiles.length > 0) {
          ModalSuccess().then(() => history.goBack());
        } else {
          const contractId = res?.data?.data?.contract_id;
          if (supportingDocumentFiles) {
            const documentsFormData = new FormData();
            documentsFormData.append("contract_id", contractId);
            supportingDocumentFiles?.map(file =>
              documentsFormData.append("documents", file)
            );

            try {
              await axios.post(
                `${urlDocuments}${mainContractDocumentsEndpoint}`,
                documentsFormData,
                { headers }
              );
              ModalSuccess().then(() => history.goBack());
            } catch (error) {
              ModalError(getErrors(error?.response));
            }
          } else {
            ModalSuccess().then(() => history.goBack());
          }
        }
      }
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingContract(false);
    }
  };

  return (
    <ContractForm
      title="Add Contract"
      handlSubmitData={handlSubmitData}
      loadingContract={loadingContract}
    />
  );
}

export default AddContract;
